import styled from "styled-components";
import { media } from "../../globalStyles";

export const Container = styled.div`
  width: 100%;
  background-color: #172029ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(221, 221, 221) !important;
`;

export const DashboardModule = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  height: 95%;
  background-color: #0f1923ff;
  border: 4.5px solid #081019ff;
  margin-top: 50px;
`;

export const DashboardTop = styled.div`
  width: 100%;
  height: 55px;
  border-top: 2px solid #614e20ff;
  border-bottom: 2px solid #614e20ff;
  background-color: #081019ff;
  display: flex;
  justify-content: center;
`;

export const DashboardTopWrapper = styled.div`
  width: 95%;
  display: flex;
  align-items: center;
  h1 {
    font-size: 18px !important;
    font-weight: 400;
  }
  strong {
    color: #8c734b;
  }
  ${media.mobile} {
    h1 {
      font-size: 14px !important;
    }
  }
`;

export const DashboardContent = styled.p`
  width: 95%;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 30px;
  margin-left: 30px;
  ${media.mobile} {
    margin-left: 10px;
  }
`;

export const GridContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const DashboardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
  gap: 5px;
  margin-top: 30px;
  gap: 20px;
  ${media.mobile} {
    margin-left: 10px;
  }
`;

export const TasksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 40px;
  width: 360px;
  .dashboard-link {
    width: 94%;
    color: whitesmoke;
    text-decoration: none;
  }
  ${media.mobile} {
    width: 95%;
  }
  ${media.tablet} {
    width: 300px;
  }
`;

export const Item = styled.div`
  width: 100%;
  height: 55px;
  border-top: 2px solid #614e20ff;
  border-bottom: 2px solid #614e20ff;
  background-color: #081019ff;
  display: flex;
  align-items: center;
`;

export const ItemTopWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 10px;
  h1 {
    font-size: 18px !important;
    font-weight: 400;
  }

  ${media.mobile} {
    h1 {
      font-size: 14px !important;
    }
  }
`;

export const UlWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: none;
  width: 95%;
  font-size: 16px;
  ul {
    margin: 0px;
    padding: 0px;
    width: 100%;
  }
  li {
    list-style: none;
    padding: 12px 0px;
    border-bottom: 1px solid #614e20ff;
  }
  ${media.mobile} {
    font-size: 13px;
  }
`;
